module.exports = "data:image/svg+xml,%3Csvg width='150' height='70' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 7'%3E%3Cpath fill='%23CB3837' d='M0,0v6h5v1h4v-1h9v-6'/%3E%3Cpath fill='%23FFF' d='M1,1v4h2v-3h1v3h1v-4h1v5h2v-4h1v2h-1v1h2v-4h1v4h2v-3h1v3h1v-3h1v3h1v-4'/%3E%3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./assets/projects/dynamic-polyfill-module/project-logo.svg
// module id = 48
// module chunks = 0